<template>
  <section>
    <el-form class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <el-form-item label="">
        <el-input style="width: 140px" v-model="filters.name" placeholder="医院名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input style="width: 140px" v-model="filters.product" placeholder="产品代码"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          style="width: 140px"
          v-model="filters.startDate"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="开始时间"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          style="width: 140px"
          v-model="filters.endDate"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="结束时间"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="filters.area" @change="getRegionList" style="width: 140px" placeholder="大区">
          <el-option v-for="item in area_list" :key="item.id" :label="item.regionName" :value="item.regionName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="filters.city" style="width: 140px" placeholder="小区">
          <el-option v-for="item in city_list" :key="item.id" :label="item.subRegionName" :value="item.subRegionName"></el-option>
        </el-select>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          v-if="!item.IsHide"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div">
      <div>
        <el-table
          border
          :max-height="tableHeight"
          :data="tabel_list"
          header-cell-class-name="header_cell_name"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA', padding: ' 7px 0 !important' }"
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
          style="width: 100%"
        >
          <el-table-column prop="zcnCode" label="医院编号" width="120"></el-table-column>
          <el-table-column prop="hospitalName" label="医院名称"></el-table-column>
          <el-table-column prop="area" label="大区" width="60"></el-table-column>
          <el-table-column prop="city" label="小区" width="60"></el-table-column>
          <el-table-column prop="positionNumber" label="填写人岗位号"></el-table-column>
          <el-table-column prop="sales" label="填写人姓名"></el-table-column>
          <el-table-column prop="category" label="产品品类"></el-table-column>
          <el-table-column prop="productCode" label="产品代码" width="80"></el-table-column>
          <el-table-column prop="currentMonthQuota" label="当月数量"></el-table-column>
          <el-table-column prop="nextMonthQuota" label="下月数量"></el-table-column>
          <el-table-column prop="amount1" label="当月预估金额"></el-table-column>
          <el-table-column prop="amount2" label="下月预估金额"></el-table-column>
          <el-table-column prop="createMonth" label="提交时间"></el-table-column>
          <el-table-column prop="subRegionStatus" label="小区审批状态"></el-table-column>
          <el-table-column prop="regionStatus" label="大区审批状态"></el-table-column>
        </el-table>
      </div>
      <!--工具条-->
      <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
          <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
          <el-pagination
            :background="true"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="50"
            :total="total"
            style="float: right"
          ></el-pagination>
        </el-col>
      </div>
    </div>

    <!-- 审批树弹窗 -->
    <el-dialog title="审批进度树" :visible.sync="showApprovalDialog" width="50%"
      :before-close="() => showApprovalDialog = false">
      <div slot="header" class="card-header">
        <span class="header-title">审批进度树</span>
      </div>

      <div v-if="treeLoading" class="loading-container">
        <el-spinner />
      </div>

      <el-tree v-else :data="treeData" :props="defaultProps" node-key="key" highlight-current
        :default-expanded-keys="expandedKeys" class="approval-tree enhanced-tree">
        <template slot-scope="{ node, data }">
          <div class="custom-tree-node enhanced-node">
            <div class="node-title enhanced-title">{{ data.title }}</div>
            <div v-if="node.level > 1 && data.status !== undefined" class="node-status enhanced-status">
              <el-tooltip  v-if="data.status === 3 && data.msg" class="item" effect="dark" :content="data.msg" placement="top" >
                <el-tag :type="statusType(data.status)" size="small" class="status-tag">  {{ statusText(data.status) }} </el-tag> 
              </el-tooltip>
              <el-tag  v-else :type="statusType(data.status)" size="small" class="status-tag">{{ statusText(data.status) }}</el-tag>
              <span class="status-time enhanced-time">
                {{ data.time || '' }}
              </span>
            </div>
          </div>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportApprovalProgress" :loading="exportLoading">导出Excel</el-button>
        <el-button @click="showApprovalDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date'
import {
  estimate_getmonthlyconsumptionlist,
  dashboard_getregionsbylevel,
  estimate_getmonthlyconsumptionexport,
  estimate_getforecastexport,
  getApprovalTreeBySd,
  exportApprovalProgressToExcel
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { quillEditor } from 'vue-quill-editor'
import { uploadfiles } from '@/uploadfiles'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Toolbar from '../../components/Toolbar'

export default {
  components: { Toolbar, quillEditor },
  data() {
    return {
      city_list: [],
      area_list: [],
      isMobile: false,
      tableHeight: 0,
      buttonList: [],
      editorOption: {
        // editorOption里是放图片上传配置参数用的，例如：
        action: '/images/Upload/Pic', // 必填参数 图片上传地址
        methods: 'post', // 必填参数 图片上传方式
        token: this.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        // name: 'upload_file',  // 必填参数 文件的参数名
        // size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        // accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg'  // 可选 可上传的图片格式
      },
      token: '',
      addLoading: false,
      editFormRules: {
        html: [{ required: true, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      currentRow: null,
      filters: {
        pageSize: 50,
        city: '',
      },
      tabel_list: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      showApprovalDialog: false,
      treeData: [],
      treeLoading: false,
      expandedKeys: [],
      exportLoading: false,
    }
  },
  methods: {
    getRegionList(value) {
      const selectedOptions = this.area_list.filter((option) => option.regionName === value)
      this.city_list = selectedOptions[0].subRegions
      this.filters.city = ''
    },
    async dashboard_getregionsbylevel() {
      const { data } = await dashboard_getregionsbylevel()
      this.area_list = data.data.regions
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val
      this.getModules()
    },
    getModules_search() {
      this.page = 1
      this.getModules()
    },
    async ExportAccount() {
      let para = this.filters
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const { data, headers } = await estimate_getmonthlyconsumptionexport(para)
      uploadfiles(data, headers, this.loading)
    },
    async ExportAccountYTD() {
      let para = this.filters
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const { data, headers } = await estimate_getforecastexport(para)
      uploadfiles(data, headers, this.loading)
    },

    //获取用户列表
    getModules() {
      let para = this.filters
      para.page = this.page
      this.listLoading = true
      estimate_getmonthlyconsumptionlist(para).then((res) => {
        this.total = res.data.dataCount
        this.tabel_list = res.data.data
        console.log(this.tabel_list)
        this.listLoading = false
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    showApprovalTreeDialog() {
      this.showApprovalDialog = true;
      this.loadApprovalTree();
    },
    async loadApprovalTree() {
      this.treeLoading = true;
      try {
        const resp = await getApprovalTreeBySd();
        this.treeData = resp.data.data || [];
        // ****** 计算 1~3 级需要展开的 key ******
        this.expandedKeys = [];
        const dfs = (nodes, level) => {
          if (!nodes || level > 2) return;
          nodes.forEach(node => {
            this.expandedKeys.push(node.key);
            dfs(node.children, level + 1);
          });
        };
        dfs(this.treeData, 1);
      } catch {
        this.$message.error('加载审批树失败');
      } finally {
        this.treeLoading = false;
      }
    },
    statusText(status) {
      const map = { 0: '待上报', 1: '待审批', 2: '通过', 3: '驳回' };
      return map[status] || '';
    },
    statusType(status) {
      if (status === 2) return 'success';
      if (status === 3) return 'danger';
      if (status === 1) return 'warning';
      return 'info';
    },
    async exportApprovalProgress() {
      this.exportLoading = true;
      try {
        const response = await exportApprovalProgressToExcel();
        const blob = new Blob([response.data], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const now = new Date();
        const dateStr = now.getFullYear().toString() + 
          (now.getMonth() + 1).toString().padStart(2, '0') + 
          now.getDate().toString().padStart(2, '0');
        link.download = `审批进度_${dateStr}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.$message.success('导出成功');
      } catch (error) {
        this.$message.error('导出失败');
      } finally {
        this.exportLoading = false;
      }
    }
  },
  mounted() {
    this.isMobile = window.innerWidth <= 767
    this.$nextTick(() => {
      this.$nextTick(() => {
        if (this.isMobile) {
          this.tableHeight = window.innerHeight - 380
        } else {
          this.tableHeight = window.innerHeight - 230
        }
      })
    })
    this.getModules()
    this.dashboard_getregionsbylevel()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
  },
}
</script>

<style scoped>
/* 弹窗整体 */
.el-dialog {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

/* 弹窗头部 */
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(90deg, #6170d7, #8593f7);
  color: #fff;
  font-size: 16px;
  padding: 12px 20px;
  font-weight: bold;
}

/* 标题 */
.header-title {
  font-size: 16px;
  font-weight: 600;
}

/* 树节点整体 */
.approval-tree {
  padding: 10px 20px;
  background: #fafafa;
  border-radius: 8px;
  min-height: 300px;
  max-height: 500px;
  overflow-y: auto;
}

/* 树节点单元 */
.custom-tree-node {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  border-radius: 6px;
  transition: background 0.3s;
}

/* 鼠标悬停 */
.custom-tree-node:hover {
  background: #eef2fd;
}

/* 节点标题 */
.node-title {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

/* 状态栏 */
.node-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 状态标签 */
.status-tag {
  font-size: 12px;
  padding: 0 6px;
  border-radius: 4px;
  font-weight: 500;
}

/* 时间样式 */
.status-time {
  font-size: 12px;
  color: #888;
}

/* 底部按钮 */
.dialog-footer {
  text-align: right;
  padding: 10px 20px;
  border-top: 1px solid #f0f0f0;
}

.dialog-footer .el-button {
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
}

</style>
